import { useEffect, useState } from 'react';
import { WifiOff, Wifi, AlertCircle } from 'lucide-react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

export function NetworkStatusIndicator() {
  const { online, wasOffline, isSlowConnection } = useNetworkStatus();
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    if (wasOffline && online) {
      setShowReconnected(true);
      const timer = setTimeout(() => {
        setShowReconnected(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [wasOffline, online]);

  // Offline indicator
  if (!online) {
    return (
      <div 
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-2 bg-error/90 text-white rounded-full shadow-lg animate-in slide-in-from-bottom-2"
        role="alert"
        aria-live="polite"
      >
        <WifiOff className="w-4 h-4" aria-hidden="true" />
        <span className="text-sm font-medium">You're offline</span>
      </div>
    );
  }

  // Reconnected notification
  if (showReconnected) {
    return (
      <div 
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-2 bg-success/90 text-white rounded-full shadow-lg animate-in slide-in-from-bottom-2"
        role="alert"
        aria-live="polite"
      >
        <Wifi className="w-4 h-4" aria-hidden="true" />
        <span className="text-sm font-medium">Back online</span>
      </div>
    );
  }

  // Slow connection warning
  if (isSlowConnection) {
    return (
      <div 
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-2 bg-warning/90 text-navy rounded-full shadow-lg"
        role="alert"
        aria-live="polite"
      >
        <AlertCircle className="w-4 h-4" aria-hidden="true" />
        <span className="text-sm font-medium">Slow connection</span>
      </div>
    );
  }

  return null;
}

export default NetworkStatusIndicator;
